import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'

export class GoalsContent extends React.PureComponent<GoalsContent.Props, GoalsContent.State> {
  public static sectionId = 'goalsco';

  public render(): JSX.Element {
    const { settings, blocks } = this.props.section

    const addLeadingZeros = (num: number, totalLength: number): string => {
      return String(num).padStart(totalLength, '0')
    }

    return (
      <section className={'goals-content bg-beige py-10 px-2 lg:px-0 lg:py-16'}>
        <div className={'max-w-6xl mx-auto'}>
          {settings.heading && (
            <Snippets.Heading tag={'h5'} className={'mb-10 leading-none text-center'}>
              {settings.heading}
            </Snippets.Heading>
          )}
          {blocks?.length && (
            <div className={'flex flex-col lg:flex-row gap-4 md:gap-2'}>
              {blocks.map((block: any, index: number) => {
                const content = block.settings
                return (
                  <div key={index + content.heading} className={`block w-full md:min-w-1/3 text-center ${index !== blocks.length - 1 ? 'border-b md:border-b-0 md:border-r border-black pr-2 pb-4 lg:pb-0' : null}`}>
                    <div className={'block-heading md:flex flex-col items-center md:min-h-120 pb-2'}>
                      <Snippets.Heading tag={'h5'} className={'mb-2 leading-none'}>
                        {addLeadingZeros(index + 1, 2)}
                      </Snippets.Heading>
                      <Snippets.Heading size={'h1'} tag={'h2'} className={'my-auto leading-none'}>
                        {content?.heading}
                      </Snippets.Heading>
                    </div>
                    <Snippets.RichText className="m-0-3 leading-normal tracking-normal">
                      {content.content}
                    </Snippets.RichText>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </section>
    )
  }

}

export namespace GoalsContent {
  export interface Options extends ShopifyNext.Section {
    content: string;
    heading: 'uppercase';
    blocks: any;
  }
  export interface Props extends GlobalProps {
    section: GoalsContent.Options;
  }
  export interface State { }
}
